import styled from "styled-components";

const SettingsButtonsWrapper = styled.div`
    width: auto;
    padding: 20px;
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: repeat(auto-fit, minmax(auto, 300px));
    grid-template-rows: repeat(auto-fit, auto);
`

export default SettingsButtonsWrapper